import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Paper, TextField, Box } from '@mui/material';
import logo from '../images/logo-cnm-blue.png';
import { useSnackbar } from 'notistack';

import api from '../service/Api';

export default function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    async function handleRegister(e) {
        e.preventDefault();

        try {
            const response = await api.post('api/register', { name, email, password, approved: false });
            enqueueSnackbar('Aguarde pela sua aprovação.', {variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'center' }});
            enqueueSnackbar(response.data.message, {variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' }});
            navigate('/');
        } catch (err) {
            enqueueSnackbar(err.response.data.message, {variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'center' }});
            enqueueSnackbar('Falha ao realizar login', {variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' }});
        }
    }

    return (
        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            <Grid item xs={10} sm={6} md={4}>
                <Paper elevation={6} style={{ padding: 20, borderRadius: 15 }}>
                    <Box display="flex" justifyContent="center" marginBottom={2}>
                        <img src={logo} alt='Logo CNM' style={{ maxWidth: '50%', height: 'auto' }} />
                    </Box>
                    <form onSubmit={handleRegister}>
                        <Box display="flex" flexDirection="column">
                            <TextField
                                variant='outlined'
                                label="Nome"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                size='small'
                                margin="normal"
                                // required
                            />
                            <TextField
                                variant='outlined'
                                label="E-mail"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                size='small'
                                margin="normal"
                                required
                            />
                            <TextField
                                variant='outlined'
                                label="Senha"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                size='small'
                                margin="normal"
                                required
                            />
                            <Grid container justifyContent="space-between" alignItems="center" marginTop={2}>
                                <Button variant='contained' type="submit" sx={{ borderRadius: '8px' }} >Registrar</Button>
                                <Button href="/" variant='text'>
                                    Login
                                </Button>
                            </Grid>
                        </Box>
                    </form>
                </Paper>
            </Grid>
        </Grid>
    );
}
